export enum LetterGrade {
  APlus = 14,
  A = 13,
  AMinus = 12,
  BPlus = 11,
  B = 10,
  BMinus = 9,
  CPlus = 8,
  C = 7,
  CMinus = 6,
  DPlus = 5,
  D = 4,
  DMinus = 3,
  FPlus = 2,
  F = 1,
  FMinus = 0,
}

export const LetterGradeValuesMap: Record<number, LetterGrade> = {
  14: LetterGrade.APlus,
  13: LetterGrade.A,
  12: LetterGrade.AMinus,
  11: LetterGrade.BPlus,
  10: LetterGrade.B,
  9: LetterGrade.BMinus,
  8: LetterGrade.CPlus,
  7: LetterGrade.C,
  6: LetterGrade.CMinus,
  5: LetterGrade.DPlus,
  4: LetterGrade.D,
  3: LetterGrade.DMinus,
  2: LetterGrade.FPlus,
  1: LetterGrade.F,
  0: LetterGrade.FMinus,
};

export const LetterGradePretty: Record<LetterGrade, string> = {
  [LetterGrade.APlus]: 'A+',
  [LetterGrade.A]: 'A',
  [LetterGrade.AMinus]: 'A-',
  [LetterGrade.BPlus]: 'B+',
  [LetterGrade.B]: 'B',
  [LetterGrade.BMinus]: 'B-',
  [LetterGrade.CPlus]: 'C+',
  [LetterGrade.C]: 'C',
  [LetterGrade.CMinus]: 'C-',
  [LetterGrade.DPlus]: 'D+',
  [LetterGrade.D]: 'D',
  [LetterGrade.DMinus]: 'D-',
  [LetterGrade.FPlus]: 'F+',
  [LetterGrade.F]: 'F',
  [LetterGrade.FMinus]: 'F-',
};
